module.exports = __webpack_public_path__ + "img/LIONS-BANNER-DISPLAYED.172a76b1.jpg";